export default __webpack_public_path__ + "hero-next-320-86dd193e17ff0b4cf21b3ff79c15f2d8.bundle.webp";